import { IColumns as IColumnsAll } from '../../../../../../components/Dashboard/Table/TableTypes'

export interface IDataAll {
  request: string
  columns: IColumnsAll[]
}

export const fiatData: IDataAll = {
  request: '',
  columns: [
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'transaction',
      label: 'TRANSACTION',
    },
    {
      id: 'date',
      label: 'DATE',
    },
    {
      id: 'amount',
      label: 'AMOUNT',
    },
    {
      id: 'priceTransaction',
      label: 'PRICE AT TRANSACTION',
    },
    {
      id: 'priceNow',
      label: 'PRICE NOW',
    },
    {
      id: 'time',
      label: 'P/L TODAY',
    },
  ],
}

export const cryptoData: IDataAll = {
  request: '',
  columns: [
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'transaction',
      label: 'TRANSACTION',
    },
    {
      id: 'date',
      label: 'DATE',
    },
    {
      id: 'amount',
      label: 'AMOUNT',
    },
    {
      id: 'priceNow',
      label: 'PRICE NOW',
    },
    {
      id: 'time',
      label: 'P/L TODAY',
    },
    {
      id: 'oneButton',
      label: '',
    },
  ],
}

export const stateFiatData = [
  {
    asset: 'BTC',
    transaction: 'Deposit',
    date: '03/05/2021',
    amount: '5.000',
    priceTransaction: '50.000',
    priceNow: '60.000',
    time: '+5%',
  },
  {
    asset: 'BTC',
    transaction: 'Deposit',
    date: '03/05/2021',
    amount: '5.000',
    priceTransaction: '50.000',
    priceNow: '60.000',
    time: '+5%',
  },
  {
    asset: 'BTC',
    transaction: 'Deposit',
    date: '03/05/2021',
    amount: '5.000',
    priceTransaction: '50.000',
    priceNow: '60.000',
    time: '+5%',
  },
]

export const stateCryptoData = [
  {
    asset: 'ETH',
    transaction: 'Deposit',
    date: '03/05/2021',
    amount: '5.000',

    priceNow: '60.000',
    time: '+5%',
  },
  {
    asset: 'BTC',
    transaction: 'Deposit',
    date: '03/05/2021',
    amount: '5.000',
    priceNow: '60.000',
    time: '+5%',
  },
  {
    asset: 'BTC',
    transaction: 'Deposit',
    date: '03/05/2021',
    amount: '5.000',
    priceNow: '60.000',
    time: '+5%',
  },
]
